import React from 'react';
import propTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useLabels } from 'wsm-common-data';
import './ShareModal.scss';

const ShareModal = ({ accountInfo, show, handleClose }) => {
	const labels = useLabels();

	if (!accountInfo) {
		return null;
	}

	const { dealerCode } = accountInfo;

	return (
		<Modal dialogClassName="poster-modal" show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>
					{labels.get('LOVE_PROMISE_SUBMIT_STORY')}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<iframe
					title={labels.get('LOVE_PROMISE_SUBMIT_STORY')}
					src={`https://www.subaru.com/content/subaru/en/love-promise/ddc-love-promisesubmissionform.html?dealerNumber=${dealerCode}`}
					scrolling="yes"
					frameBorder="0"
					// eslint-disable-next-line react/no-unknown-property -- legacy iframe attribute
					allowTransparency="true"
					className="story-submission-modal"
				/>
			</Modal.Body>
		</Modal>
	);
};

ShareModal.propTypes = {
	accountInfo: propTypes.shape({
		dealerCode: propTypes.string
	}).isRequired,
	show: propTypes.bool.isRequired,
	handleClose: propTypes.func.isRequired
};

export default ShareModal;
